'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _offkey = require('offkey');

var _lodash = require('lodash');

var _KeyHandler = require('./KeyHandler');

var _KeyHandler2 = _interopRequireDefault(_KeyHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 */
var Tab = function Tab(_ref) {
	var _ref2;

	var id = _ref.id;
	var panelId = _ref.panelId;
	var name = _ref.name;
	var title = _ref.title;
	var active = _ref.active;
	var onActive = _ref.onActive;
	var onFirst = _ref.onFirst;
	var onLast = _ref.onLast;
	var onPrevious = _ref.onPrevious;
	var onNext = _ref.onNext;

	var handleClick = function handleClick() {
		return onActive(name);
	};
	var handlePrevious = function handlePrevious() {
		return onPrevious(name);
	};
	var handleNext = function handleNext() {
		return onNext(name);
	};

	var className = (0, _classnames2.default)(_defineProperty({
		'rea11y-Tab': true,
		'rea11y-Tab--active': active
	}, 'rea11y-Tab-' + name, true));

	return _react2.default.createElement(
		_KeyHandler2.default,
		{
			handlers: (_ref2 = {}, _defineProperty(_ref2, _offkey.HOME, onFirst), _defineProperty(_ref2, _offkey.END, onLast), _defineProperty(_ref2, _offkey.ARROW.UP, handlePrevious), _defineProperty(_ref2, _offkey.ARROW.LEFT, handlePrevious), _defineProperty(_ref2, _offkey.ARROW.DOWN, handleNext), _defineProperty(_ref2, _offkey.ARROW.RIGHT, handleNext), _ref2)
		},
		_react2.default.createElement(
			'button',
			{
				id: id,
				className: className,
				role: 'tab',
				'aria-controls': panelId,
				'aria-selected': active,
				onClick: handleClick,
				tabIndex: active ? 0 : -1
			},
			title
		)
	);
};

Tab.propTypes = {
	id: _react.PropTypes.string,
	panelId: _react.PropTypes.string,
	name: _react.PropTypes.string,
	title: _react.PropTypes.string,
	active: _react.PropTypes.bool,
	onActive: _react.PropTypes.func,
	onFirst: _react.PropTypes.func,
	onLast: _react.PropTypes.func,
	onPrevious: _react.PropTypes.func,
	onNext: _react.PropTypes.func
};

Tab.defaultProps = {
	active: false,
	onActive: _lodash.noop,
	onFirst: _lodash.noop,
	onLast: _lodash.noop,
	onPrevious: _lodash.noop,
	onNext: _lodash.noop
};

exports.default = (0, _recompose.pure)(Tab);